import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Injector } from '@angular/core';
import { OnboardingWidgetModule } from '@core/widgets';
import { User } from 'lingo2-models';
import { AbstractPane } from '../../models/abstract-pane';

@Component({
  selector: 'app-widget-onboarding',
  standalone: true,
  imports: [CommonModule, OnboardingWidgetModule],
  templateUrl: './widget-onboarding.component.html',
  styleUrls: ['./widget-onboarding.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetOnboardingComponent extends AbstractPane {
  protected me: User;
  public openModal = false;

  constructor(protected readonly inject: Injector) {
    super(inject);
  }
  protected onContentLoaded(): void {
    this.isVisible = true;
  }
}
